var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 9H1.83333C1.3471 9 0.880787 8.80687 0.536973 8.463C0.193153 8.1192 0 7.65287 0 7.16667V1.83333C0 1.3471 0.193153 0.880787 0.536973 0.536973C0.880787 0.193153 1.3471 0 1.83333 0H7.16667C7.65287 0 8.1192 0.193153 8.463 0.536973C8.80687 0.880787 9 1.3471 9 1.83333V7.16667C9 7.65287 8.80687 8.1192 8.463 8.463C8.1192 8.80687 7.65287 9 7.16667 9ZM1.83333 1C1.61232 1 1.40036 1.0878 1.24408 1.24408C1.0878 1.40036 1 1.61232 1 1.83333V7.16667C1 7.38767 1.0878 7.59967 1.24408 7.75593C1.40036 7.9122 1.61232 8 1.83333 8H7.16667C7.38767 8 7.59967 7.9122 7.75593 7.75593C7.9122 7.59967 8 7.38767 8 7.16667V1.83333C8 1.61232 7.9122 1.40036 7.75593 1.24408C7.59967 1.0878 7.38767 1 7.16667 1H1.83333Z",
    fill: "#7C7C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 12H4.83333C4.3471 12 3.88079 11.8069 3.53697 11.463C3.19315 11.1192 3 10.6529 3 10.1667V8.83333H4V10.1667C4 10.3877 4.0878 10.5997 4.24408 10.7559C4.40036 10.9122 4.61232 11 4.83333 11H10.1667C10.3877 11 10.5997 10.9122 10.7559 10.7559C10.9122 10.5997 11 10.3877 11 10.1667V4.83333C11 4.61232 10.9122 4.40036 10.7559 4.24408C10.5997 4.0878 10.3877 4 10.1667 4H8.83333V3H10.1667C10.6529 3 11.1192 3.19315 11.463 3.53697C11.8069 3.88079 12 4.3471 12 4.83333V10.1667C12 10.6529 11.8069 11.1192 11.463 11.463C11.1192 11.8069 10.6529 12 10.1667 12Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/Clone.2533eeaffcc1ca73a15c8359aa9c44dc.svg";
export { ForwardRef as ReactComponent };